import classNames from "classnames";
import {
  FiActivity,
  FiAlertTriangle,
  FiArrowDown,
  FiArrowUp,
  FiBellOff,
  FiCheck,
  FiEye,
  FiPause,
  FiSearch,
  FiTool,
} from "react-icons/fi";
import {GrHistory} from "react-icons/gr";

import {Icon} from "@/components/icon/Icon.tsx";
import {KPIIconDisplayConfig, KPIIconType, KPIIconTypes} from "@/components/KPIIcon/KPIIcon.types.ts";

import styles from "./KPIIcon.module.scss";

const KPIIconMap: Record<KPIIconType, KPIIconDisplayConfig> = {
  // Alerts
  [KPIIconTypes.ALERTS_ACTIVE]: {
    icon: FiAlertTriangle,
    backgroundColor: "pulse-bg-red-100",
    borderColor: "pulse-border-red-200",
    iconColor: "pulse-color-red-600",
  },
  [KPIIconTypes.ALERTS_IGNORED]: {
    icon: FiBellOff,
    backgroundColor: "pulse-bg-blue-100",
    borderColor: "pulse-border-blue-200",
    iconColor: "pulse-color-blue-600",
  },
  [KPIIconTypes.ALERTS_LAST]: {
    icon: GrHistory,
    backgroundColor: "pulse-bg-gray-200",
    borderColor: "pulse-border-gray-400",
    iconColor: "pulse-color-gray-600",
  },
  [KPIIconTypes.ALERTS_RESOLVED]: {
    icon: FiCheck,
    backgroundColor: "pulse-bg-green-100",
    borderColor: "pulse-border-green-200",
    iconColor: "pulse-color-green-600",
  },
  // Checks
  [KPIIconTypes.CHECKS_UP]: {
    icon: FiArrowUp,
    backgroundColor: "pulse-bg-green-100",
    borderColor: "pulse-border-green-200",
    iconColor: "pulse-color-green-600",
  },
  [KPIIconTypes.CHECKS_DOWN]: {
    icon: FiArrowDown,
    backgroundColor: "pulse-bg-red-100",
    borderColor: "pulse-border-red-200",
    iconColor: "pulse-color-red-600",
  },
  [KPIIconTypes.CHECKS_MAINTENANCE]: {
    icon: FiTool,
    backgroundColor: "pulse-bg-yellow-100",
    borderColor: "pulse-border-yellow-300",
    iconColor: "pulse-color-yellow-600",
  },
  [KPIIconTypes.CHECKS_PAUSED]: {
    icon: FiPause,
    backgroundColor: "pulse-bg-gray-200",
    borderColor: "pulse-border-gray-400",
    iconColor: "pulse-color-gray-600",
  },
  [KPIIconTypes.CHECKS_RUNNING]: {
    icon: FiActivity,
    backgroundColor: "pulse-bg-green-100",
    borderColor: "pulse-border-green-200",
    iconColor: "pulse-color-green-600",
  },
  // Incidents
  [KPIIconTypes.INCIDENTS_IDENTIFIED]: {
    icon: FiSearch,
    backgroundColor: "pulse-bg-blue-100",
    borderColor: "pulse-border-blue-200",
    iconColor: "pulse-color-blue-600",
  },
  [KPIIconTypes.INCIDENTS_INVESTIGATING]: {
    icon: FiEye,
    backgroundColor: "pulse-bg-orange-100",
    borderColor: "pulse-border-orange-200",
    iconColor: "pulse-color-orange-600",
  },
  [KPIIconTypes.INCIDENTS_MAINTENANCE]: {
    icon: FiTool,
    backgroundColor: "pulse-bg-yellow-100",
    borderColor: "pulse-border-yellow-300",
    iconColor: "pulse-color-yellow-600",
  },
  [KPIIconTypes.INCIDENTS_MONITORING]: {
    icon: FiActivity,
    backgroundColor: "pulse-bg-tangerine-100",
    borderColor: "pulse-border-tangerine-200",
    iconColor: "pulse-color-tangerine-500",
  },
  [KPIIconTypes.INCIDENTS_RESOLVED]: {
    icon: FiCheck,
    backgroundColor: "pulse-bg-green-100",
    borderColor: "pulse-border-green-200",
    iconColor: "pulse-color-green-600",
  },
  [KPIIconTypes.INCIDENTS_ACTIVE]: {
    icon: FiAlertTriangle,
    backgroundColor: "pulse-bg-red-100",
    borderColor: "pulse-border-red-200",
    iconColor: "pulse-color-red-600",
  },
};

interface KPIIconProps {
  type: KPIIconType;
}

export const KPIIcon = ({type}: KPIIconProps) => {
  const typeConfig = KPIIconMap[type];

  return (
    <Icon
      icon={typeConfig.icon}
      shape={"square"}
      size="kpi"
      className={classNames(typeConfig.iconColor, typeConfig.borderColor, typeConfig.backgroundColor, styles.kpiIcon)}
    />
  );
};
